import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';

export const leadScreeningMeetingDateFilterConfig = createDateRangeFilterConfig(
  {
    facetName: buildDateRangeFacetKey({
      before: 'screening_meeting_date_before',
      after: 'screening_meeting_date_after',
    }),
  }
);
